<template>
  <div>
    <div class="tw:mb-4">
      <Checkbox
        name="select-all"
        label="app_images_actions_select_all"
        :value="isAllSelected()"
        @onChange="e => selectAllItems(e)"
      />
    </div>

    <div class="tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:md:grid-cols-3 tw:lg:grid-cols-4 tw:gap-4">
      <template v-for="(image, index) in items" :key="`image-${index}`">
        <div v-if="image?.active" class="tw:flex tw:items-center tw:justify-center tw:min-h-[187px]">
          <ImageElement
            :id="image?.imageId"
            :imageUrl="`https://imgcy.trivago.com/c_fill,d_dummy.jpeg,e_sharpen:60,f_auto,h_208,q_auto,w_231/${image?.imagePath}`"
            :image="image"
            :is-main-image="image?.isMainImage"
            :is-selected="isImageSelected(image?.imageId)"
            :open-id="openId"
            :images="items"
            :custom-properties="image?.customProperties"
            @toggleDeleteModal="imageId => emit('toggleDeleteModal', imageId)"
            @openSetMainImageModal="emit('openSetMainImageModal', image)"
            @openImageGallery="emit('openImageGallery', image)"
            @toggleMenu="toggleMenu"
            @selectImage="selectOneImage"
          />
        </div>
      </template>

      <template v-for="(image, index) in uploadingImages" :key="`uploading-${index}`">
        <div
          v-if="image?.status && image.status.toLowerCase() === 'uploading'"
          class="tw:flex tw:items-center tw:justify-center tw:min-h-[187px]"
        >
          <LoadingImageElement :item="image" />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Checkbox from '@/components/base/inputs/Checkbox.vue'
import ImageElement from '@/components/propertyDetails/propertyImages/ImageElement.vue'
import LoadingImageElement from '@/components/propertyDetails/propertyImages/LoadingImageElement.vue'
import { usePropertyImages } from '@/components/propertyDetails/propertyImages/usePropertyImages.ts'

const { selectedImageIds, selectImage, selectAll, uploadingImages } = usePropertyImages()

const emit = defineEmits(['toggleDeleteModal', 'openImageGallery', 'openSetMainImageModal'])

const props = defineProps({
  items: Array,
})

const openId = ref(null)

const isImageSelected = id => {
  return selectedImageIds !== null && selectedImageIds.value.includes(id)
}

const isAllSelected = () => {
  const allSelectableImages = props.items.filter(item => item.customProperties.isDeletable && !item.isMainImage)
  return allSelectableImages.length === selectedImageIds.value.length
}

const selectAllItems = e => {
  selectAll(e, props.items)
}

const selectOneImage = (e, id) => {
  selectImage(id)
}

const toggleMenu = id => {
  if (id === openId.value) {
    openId.value = null
  } else {
    openId.value = id
  }
}
</script>
